import { createTypedHooks } from 'easy-peasy';

const typedHooks = createTypedHooks();

export const storeActions = typedHooks.useStoreActions;
export const storeDispatch = typedHooks.useStoreDispatch;
export const storeState = typedHooks.useStoreState;